import { render, staticRenderFns } from "./mental-health-top-stressor-cause-card.vue?vue&type=template&id=1a93022a&scoped=true&"
import script from "./mental-health-top-stressor-cause-card.vue?vue&type=script&lang=js&"
export * from "./mental-health-top-stressor-cause-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a93022a",
  null
  
)

export default component.exports